export function calculateCreditUsage(
  isRegularDefault: boolean = false,
  userCredit,
  userPaidCredits,
  defaultCreditCost,
  defaultPremiumCreditCost = defaultCreditCost,
) {
  const hasRegularCredits = userCredit?.credits;
  const hasPaidCredits = userPaidCredits > 0;
  
  const regularCredits = 
  hasRegularCredits || 
  (!hasRegularCredits && !hasPaidCredits) ? 
  defaultCreditCost : 0

  const premiumCredits = 
  (isRegularDefault && !hasRegularCredits && hasPaidCredits) ? defaultPremiumCreditCost :  
  (isRegularDefault && hasRegularCredits) || (isRegularDefault && !hasPaidCredits && !hasRegularCredits) || 
  (!isRegularDefault && !hasPaidCredits) ? 0 : 
  (!isRegularDefault && hasPaidCredits && hasRegularCredits ? 1 : 
    defaultPremiumCreditCost)

  return { regularCredits, premiumCredits }
}